import qs from 'query-string';
import moment from 'moment';
import { apiConfig } from '../api-config';

export interface GenerateLinkGixParams {
  TokenKey: string;
  NameTerritory: string;
  CdTerritory: string;
  CdUser: number;
  TaskDate?: string;
  CdJourneyModel: number;
  CdJourneyGroupModel: number;
  CdJourneyGroupTaskModel: number[];
}

export const generateLinkGix = (params: GenerateLinkGixParams) => {
  const currentDate = moment().add(7, 'days').format('DD/MM/YYYY');

  const query = qs.stringify({
    ...params,
    TaskDate: currentDate,
  });

  return apiConfig
    .get(`api/Gix/create-link?${query}`)
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
};
